import { parseJSONData } from '../lib/json.ts'
import { propertyInterestDataSchema } from '../interests/types.ts'
import type { RespondedQuestionnaireAnswers } from '../questionnaires/types.ts'
import type { ContactFeedbackInterest, ParsedContact, ParsedContactFeedback, RawContact } from './types.ts'

function extractAnswersFromInterests(interests: ContactFeedbackInterest[]): RespondedQuestionnaireAnswers {
  const sorted = [...interests].sort(
    (interestA, interestB) =>
      new Date(interestB.created_at).getTime() - new Date(interestA.created_at).getTime()
  )

  for (const interest of sorted) {
    if (!interest.data) {
      continue
    }

    const parsed = parseJSONData(interest.data, propertyInterestDataSchema)

    if (parsed?.answers.length) {
      return parsed.answers
    }
  }

  return []
}

function deriveAnswers(feedback: ParsedContactFeedback[]): RespondedQuestionnaireAnswers {
  const completedWithInterests = feedback
    .filter((item) => item.completed_at && item.interests?.length)
    .sort(
      (itemA, itemB) =>
        new Date(itemB.completed_at!).getTime() - new Date(itemA.completed_at!).getTime()
    )

  for (const item of completedWithInterests) {
    const answers = extractAnswersFromInterests(item.interests!)

    if (answers.length) {
      return answers
    }
  }

  return []
}

export function parseContact(rawContact: RawContact): ParsedContact {
  const { feedback, ...restOfContact } = rawContact
  const parsedFeedback = feedback ?? []

  return {
    ...restOfContact,
    feedback: parsedFeedback,
    assets: [],
    answers: deriveAnswers(parsedFeedback),
  }
}
